export default class Modal
{
  constructor()
  {
    if (!this.setVars()) return;
    
    this.setEvents();
  }
  
  setVars()
  {
    this.settings = {
      main: 'data-modal',
      open: 'data-modal-open',
      close: 'data-modal-close',
    };
    
    this.modals = document.querySelectorAll(`[${this.settings.main}]`);
    this.modalClose = document.querySelectorAll(`[${this.settings.close}]`);
    this.modalOpen = document.querySelectorAll(`[${this.settings.open}]`);
    
    if (!this.modals) return;
    
    return true;
  }
  
  setEvents()
  {
    this.modalOpen.forEach(open => {
      open.addEventListener('click', () => {
        const modalName = open.getAttribute(this.settings.open);
        document.querySelector(`[${this.settings.main}="${modalName}"]`).addClass('active');
        document.querySelector(`[data-blur]`).addClass('active');
      })
    });
    
    this.modalClose.forEach(close => {
      close.addEventListener('click', () => {
        this.modals.forEach(modal => {
          modal.removeClass('active');
          document.querySelector(`[data-blur]`).removeClass('active');
        })
      })
    });
  }
}
